import React from 'react';
import { NavLink } from 'react-router-dom';
import SocialIcons from '../SocialIcons';

const Navigation = () => {
  return (
    <nav className="ms-auto">
      <ul className='list-unstyled'>
        <li>
          <NavLink className="nav-link text-accent" to="/">
            /home
          </NavLink>
        </li>
        <li>
          <NavLink className="nav-link text-accent" to="/profile">
            /profile
          </NavLink>
        </li>
        <li>
          <NavLink className="nav-link text-accent" to="/resume">
            /resume
          </NavLink>
        </li>
        <li>
          <NavLink className="nav-link text-accent" to="/portfolio">
            /portfolio
          </NavLink>
        </li>
        <li>
          <NavLink className="nav-link text-accent" to="/certifications">
            /certifications
          </NavLink>
        </li>
        <li>
            <SocialIcons />    
        </li>
      </ul>

    </nav>
  );
};

export default Navigation;
